/* eslint-disable no-console */
import * as Sentry from '@sentry/browser'

const SeverityLevels = {
  Fatal: 'fatal',
  Error: 'error',
  Warning: 'warning',
  Info: 'info',
  Debug: 'debug',
}

export const log = {
  fatal(message) {
    sendLog(message, SeverityLevels.Fatal)
  },
  error(message) {
    sendLog(message, SeverityLevels.Error)
  },
  warning(message) {
    sendLog(message, SeverityLevels.Warning)
  },
  info(message) {
    sendLog(message, SeverityLevels.Info)
  },
  debug(message) {
    sendLog(message, SeverityLevels.Debug)
  },
}

function sendLog(message, level) {
  if (shouldIgnoreError(message)) return

  print(message, level)

  Sentry.withScope(scope => {
    scope.setLevel(level)
    if (message instanceof Error) {
      Sentry.captureException(message)
    } else {
      Sentry.captureMessage(message, level)
    }
  })
}

const ignoreMessages = [
  'GraphQL error: you must be logged in',
  'The user aborted a request',
  `Unexpected token '<', "<HEAD><TIT"... is not valid JSON`,
]

function shouldIgnoreError(error) {
  const message = error.message ?? error
  return ignoreMessages.includes(message)
}

function print(message, level) {
  switch (level) {
    case SeverityLevels.Fatal:
    case SeverityLevels.Error:
      return console.error(message)
    case SeverityLevels.Warning:
      return console.warn(message)
    case SeverityLevels.Info:
      return console.info(message)
    case SeverityLevels.Debug:
    default:
      return console.log(message)
  }
}
